
// LogoConnections.js
import React from "react";
import { motion } from "framer-motion";
import jrslogo from "../images/jrslogo.png";

const LogoConnections = ({ role = "vendoruser", buyerLogo, clientLogo }) => {
  const userRole = (role || "").toLowerCase();

  const containerStyle =
    "relative w-64 h-auto rounded-2xl shadow-xl bg-white/90 border border-gray-200 backdrop-blur-sm p-4  flex items-center justify-center";

  // 🔹 Reusable Logo (with fallback first letter)
  const Logo = ({
    src,
    alt,
    label,
    size = "w-12 h-12",
    imgSize = "w-10 h-10",
  }) => {
    const fallbackLetter = label ? label.charAt(0).toUpperCase() : "?";

    return (
      <motion.div
        initial={{ scale: 0.6, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 120 }}
        className="text-center"
      >
        <div
          className={`${size} rounded-full bg-white border shadow-md flex items-center justify-center overflow-hidden`}
        >
          {src ? (
            <img src={src} alt={alt} className={`${imgSize} object-contain`} />
          ) : (
            <span className="text-lg font-bold text-gray-700">
              {fallbackLetter}
            </span>
          )}
        </div>
      </motion.div>
    );
  };

  // 🔹 Only JRS (Superadmin)
  if (userRole === "superadmin") {
    return (
      <div className={containerStyle}>
        <Logo
          src={jrslogo}
          alt="JRS"
          size="w-14 h-14"
          imgSize="w-12 h-12"
        />
      </div>
    );
  }
console.log("role:", role, "buyerLogo:", buyerLogo, "clientLogo:", clientLogo);

  // 🔹 Buyer + JRS (Vendoradmin)
  if (userRole === "vendoradmin") {
    return (
      <div className="relative w-64 h-auto rounded-2xl shadow-xl bg-white/90 border border-gray-200 backdrop-blur-sm  flex items-center justify-between px-10 py-4">
        {/* Buyer */}
        <div className="relative z-10">
          <Logo src={buyerLogo} alt="Buyer"  />
        </div>

        {/* Animated connecting line */}
        <svg
          className="absolute top-1/2 left-0 w-full h-0.5 pointer-events-none"
          preserveAspectRatio="none"
        >
          <motion.line
            x1="25%"
            y1="0"
            x2="75%"
            y2="0"
            stroke="#2b6777"
            strokeWidth="2.5"
            strokeDasharray="6,6"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8 }}
          />
          <motion.line
            x1="25%"
            y1="0"
            x2="75%"
            y2="0"
            stroke="#52a7a7"
            strokeWidth="2.5"
            strokeDasharray="12,12"
            strokeLinecap="round"
            animate={{ strokeDashoffset: [-24, 0] }}
            transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
          />
        </svg>

        {/* JRS */}
        <div className="relative z-10">
          <Logo src={jrslogo} alt="JRS"  />
        </div>
      </div>
    );
  }

  // 🔹 Buyer + Client + JRS (Vendoruser)
  if (userRole === "vendoruser") {
    return (
      <div className="relative w-64 h-32 rounded-2xl shadow-xl bg-white/90 border border-gray-200 backdrop-blur-sm p-4">
        <svg
          className="absolute inset-0 w-full h-full pointer-events-none"
          viewBox="0 0 256 160"
        >
          {/* Left branch */}
          <motion.line
            x1="64"
            y1="40"
            x2="128"
            y2="120"
            stroke="#2b6777"
            strokeWidth="2.5"
            strokeDasharray="6,6"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8 }}
          />
          <motion.line
            x1="64"
            y1="40"
            x2="128"
            y2="120"
            stroke="#52a7a7"
            strokeWidth="2.5"
            strokeDasharray="12,12"
            strokeLinecap="round"
            animate={{ strokeDashoffset: [-24, 0] }}
            transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }}
          />

          {/* Right branch */}
          <motion.line
            x1="192"
            y1="40"
            x2="128"
            y2="120"
            stroke="#2b6777"
            strokeWidth="2.5"
            strokeDasharray="6,6"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          />
          <motion.line
            x1="192"
            y1="40"
            x2="128"
            y2="120"
            stroke="#52a7a7"
            strokeWidth="2.5"
            strokeDasharray="12,12"
            strokeLinecap="round"
            animate={{ strokeDashoffset: [-24, 0] }}
            transition={{ repeat: Infinity, duration: 1.5, ease: "linear", delay: 0.2 }}
          />

          {/* Top bar */}
          <motion.line
            x1="64"
            y1="40"
            x2="192"
            y2="40"
            stroke="#2b6777"
            strokeWidth="2.5"
            strokeDasharray="6,6"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          />
          <motion.line
            x1="64"
            y1="40"
            x2="192"
            y2="40"
            stroke="#52a7a7"
            strokeWidth="2.5"
            strokeDasharray="12,12"
            strokeLinecap="round"
            animate={{ strokeDashoffset: [-24, 0] }}
            transition={{ repeat: Infinity, duration: 1.5, ease: "linear", delay: 0.4 }}
          />
        </svg>

        {/* Buyer */}
<div className="absolute top-4 left-12">
  <Logo src={buyerLogo} alt="Buyer" label="Buyer" />
</div>

{/* Client */}
<div className="absolute top-4 right-12">
  <Logo src={clientLogo} alt="Client" label="Client" />
</div>

{/* JRS */}
<div className="absolute bottom-4 left-1/2 -translate-x-1/2">
  <Logo src={jrslogo} alt="JRS" label="JRS" size="w-10 h-10" imgSize="w-8 h-8" />
</div>

      </div>
    );
  }

  return null;
};

export default LogoConnections;
